import { Component, ViewEncapsulation } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { homeUrl, initKeycloakForLogin } from './auth-realm';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent {
  realms = environment.KC_REALMS;
  iniciandoRealm: string | null = null;
  error = '';

  constructor(private keycloak: KeycloakService) {}

  async ingresar(realm: string): Promise<void> {
    if (!realm) { 
      return;
    }

    this.iniciandoRealm = realm;
    this.error = '';

    try {
      const authenticated = await initKeycloakForLogin(this.keycloak, realm);
      if (authenticated) {
        window.location.href = homeUrl(realm);
      }
    } catch (e) {
      console.error(e);
      this.error = 'No se pudo iniciar sesión.';
      this.iniciandoRealm = null;
    }
  }
}
